import { render } from "./catering.vue?vue&type=template&id=6bedcacb&scoped=true"
import script from "./catering.vue?vue&type=script&lang=js"
export * from "./catering.vue?vue&type=script&lang=js"

import "./catering.vue?vue&type=style&index=0&id=6bedcacb&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bedcacb"]])

export default __exports__